<div class="percent-container">
    <p>{{ percent }}%</p>
</div>
